/* eslint-disable import/first, import/order */
import Vue from 'vue'

// Shared
import Grid from '@/components/shared/grid'
import GridItem from '@/components/shared/grid-item'

Vue.component('Grid', Grid)
Vue.component('GridItem', GridItem)

// Organisms
import OfficesList from '@/components/organisms/o-list-offices/o-list-offices'
Vue.component('OOfficesList', OfficesList)
Vue.component('BlokOOfficesList', OfficesList)

import OurPractices from '@/components/organisms/o-list-practices/o-list-practices'
Vue.component('BlokOPracticesList', OurPractices)
Vue.component('OPractices', OurPractices)
Vue.component('OPracticesList', OurPractices)

import OHeroTextblock from '@/components/organisms/o-hero-text/o-hero-text-v2'
Vue.component('OHeroTextBlock', OHeroTextblock)
Vue.component('OHeroText', OHeroTextblock)

import OCarouselMain from '@/components/organisms/o-carousel/o-carousel-v2'
Vue.component('OCarouselV2', OCarouselMain)

import OFeaturedArticle from '@/components/organisms/o-featured-article/o-featured-article'
Vue.component('OFeaturedArticle', OFeaturedArticle)

import OListNewsV2 from '@/components/organisms/o-list-news/o-list-news-v2'
Vue.component('OListNewsV2', OListNewsV2)

import OClientsV2 from '@/components/organisms/o-clients/o-clients-v2'
Vue.component('OClientsV2', OClientsV2)

import OHeroImage from '@/components/organisms/o-hero-image/o-hero-image'
Vue.component('OBanner', OHeroImage)
Vue.component('BlokOBanner', OHeroImage)
Vue.component('OHeroImage', OHeroImage)

import OSiteHeaderV2 from '~/components/organisms/o-site-header/o-site-header-v2'
Vue.component('OSiteHeaderV2', OSiteHeaderV2)

import OSiteFooterV2 from '~/components/organisms/o-site-footer/o-site-footer-v2'
Vue.component('OSiteFooterV2', OSiteFooterV2)

import OArticleV2 from '~/components/organisms/o-article-v2/o-article-v2'
Vue.component('OArticleV2', OArticleV2)

import OArticleV3 from '~/components/organisms/o-article-v2/o-article-v3'
Vue.component('OArticleV3', OArticleV3)

import OAwardsV2 from '~/components/organisms/o-awards/o-awards-v2'
Vue.component('OAwardsV2', OAwardsV2)

import OContactLeadsV2 from '~/components/organisms/o-contact-leads/o-contact-leads-v2'
Vue.component('OContactLeadsV2', OContactLeadsV2)

import OListWork from '~/components/organisms/o-list-work/o-list-work'
Vue.component('OListWork', OListWork)

import OListPracticesV2 from '~/components/organisms/o-list-practices/o-list-practices-v2'
Vue.component('OListPracticesV2', OListPracticesV2)

import OFeatures from '~/components/organisms/o-features/o-features'
Vue.component('OFeatures', OFeatures)

import OX3ColumnText from '~/components/organisms/o-x3-column-text/o-x3-column-text'
Vue.component('OX3ColumnText', OX3ColumnText)

import OX4ColumnText from '~/components/organisms/o-x4-column-text/o-x4-column-text'
Vue.component('OX4ColumnText', OX4ColumnText)

import OListOfficesV2 from '~/components/organisms/o-list-offices/o-list-offices-v2'
Vue.component('OListOfficesV2', OListOfficesV2)

import OListNewsV1 from '~/components/organisms/o-list-news/o-list-news-v1'
Vue.component('OListNewsV1', OListNewsV1)

import OLayoutX2Row from '~/components/organisms/o-layout-x2-row/o-layout-x2-row'
Vue.component('OLayoutX2Row', OLayoutX2Row)

import OJobDetail from '~/components/organisms/o-job-detail/o-job-detail'
Vue.component('OJobDetail', OJobDetail)

import OListJobV1 from '~/components/organisms/o-list-jobs/o-list-jobs-v1'
Vue.component('OListJobsV1', OListJobV1)

import OHealthTextHero from '~/components/organisms/o-health/o-health-text-hero'
Vue.component('OHealthTextHero', OHealthTextHero)

import OHealthX1Sq from '~/components/organisms/o-health/o-health-x1-sq'
Vue.component('OHealthX1Sq', OHealthX1Sq)

import OHealthX4Sq from '~/components/organisms/o-health/o-health-x4-sq'
Vue.component('OHealthX4Sq', OHealthX4Sq)

import OEventbriteWidget from '@/components/organisms/o-eventbrite-widget/o-eventbrite-widget'
Vue.component('OEventbriteWidget', OEventbriteWidget)

import OClientV3 from '@/components/organisms/o-clients/o-clients-v3'
Vue.component('OClientV3', OClientV3)

import OWrapperOverlap from '@/components/organisms/o-wrapper-overlap/o-wrapper-overlap'
Vue.component('OWrapperOverlap', OWrapperOverlap)

import OFeaturesV2 from '@/components/organisms/o-features/o-features-v2'
Vue.component('OFeaturesV2', OFeaturesV2)

import OArticleHeader from '@/components/organisms/o-article-header/o-article-header'
Vue.component('OArticleHeader', OArticleHeader)

// Atoms
import Heading from '@/components/atoms/a-headings/a-heading'
Vue.component('AHeading', Heading)

import Cta from '@/components/atoms/a-ctas/a-cta-v2'
Vue.component('ACta', Cta)

import Eyebrow from '@/components/atoms/a-eyebrow/a-eyebrow'
Vue.component('AEyebrow', Eyebrow)

import ACopy from '@/components/atoms/a-copy/a-copy'
Vue.component('ACopy', ACopy)

import ALinkV2 from '~/components/atoms/a-links/a-link-v2'
Vue.component('ALinkV2', ALinkV2)

import AImageV2 from '~/components/atoms/a-images/a-image-v2'
Vue.component('AImageV2', AImageV2)

import ALottie from '@/components/atoms/a-lottie/a-lottie'
Vue.component('ALottie', ALottie)

// Molecules
import ArticleImage from '@/components/molecules/m-articles/m-article-image'
Vue.component('MArticleImage', ArticleImage)
Vue.component('BlokMArticleWithImage', ArticleImage)
Vue.component('BlokMArticleImage', ArticleImage)

import CarouselNav from '@/components/molecules/m-navs/m-nav-carousel'
Vue.component('MCarouselNav', CarouselNav)

import ArticleQuote from '@/components/molecules/m-articles/m-article-quote'
Vue.component('BlokMArticleQuote', ArticleQuote)
Vue.component('MArticleQuote', ArticleQuote)

import ArticleSingle from '@/components/molecules/m-articles/m-article-single'
Vue.component('MArticleSingle', ArticleSingle)

import ArticleText from '@/components/molecules/m-articles/m-article-text'
Vue.component('MArticleText', ArticleText)
Vue.component('BlokMArticleText', ArticleText)

import MArticleTextV2 from '@/components/molecules/m-articles/m-article-text-v2'
Vue.component('MArticleTextV2', MArticleTextV2)

import MArticleTextWide from '@/components/molecules/m-articles/m-article-text-wide'
Vue.component('MArticleTextWide', MArticleTextWide)

import MArticleWithImage from '~/components/molecules/m-articles/m-article-with-image'
Vue.component('MArticleWithImage', MArticleWithImage)

import MArticleMedia from '~/components/molecules/m-articles/m-article-media'
Vue.component('MArticleMedia', MArticleMedia)

import MArticleStats from '~/components/molecules/m-articles/m-article-stats'
Vue.component('MArticleStats', MArticleStats)

import MArticleQuoteV2 from '~/components/molecules/m-articles/m-article-quote-v2'
Vue.component('MArticleQuoteV2', MArticleQuoteV2)

import MArticleSection from '~/components/molecules/m-articles/m-article-section'
Vue.component('MArticleSection', MArticleSection)

import MArticle2Column from '~/components/molecules/m-articles/m-article-2-column'
Vue.component('MArticle2Column', MArticle2Column)

import MArticle2ColumnStats from '~/components/molecules/m-articles/m-article-2-column-stats'
Vue.component('MArticle2ColumnStats', MArticle2ColumnStats)

import MPractices from '~/components/molecules/m-practices/m-practices'
Vue.component('MPracticesList', MPractices)

import MArticleWrapperOverlap from '@/components/molecules/m-articles/m-article-wrapper-overlap'
Vue.component('MArticleWrapperOverlap', MArticleWrapperOverlap)

import OLargeText from '@/components/organisms/o-large-text/o-large-text'
Vue.component('OLargeText', OLargeText)

import OHalfText from '@/components/organisms/o-half-text/o-half-text'
Vue.component('OHalfText', OHalfText)

import ASpacer from '@/components/atoms/a-spacer/a-spacer'
Vue.component('ASpacer', ASpacer)

import SlideInView from '@/components/shared/slide-in.vue'
Vue.component('SlideInView', SlideInView)

// Deprecated
import ScrollIndicator from '@/components/_archive/a-scroll-indicator'
import ArticleVideo from '@/components/_archive/m-article-video'
import FeatureCard from '~/components/_archive/m-feature-card'
import LondonOffice from '~/components/_archive/m-london-office'
import OfficeCard from '~/components/_archive/m-office-card'
import PracticeLeadItem from '~/components/_archive/m-practice-lead-item'
import SectionHeader from '~/components/_archive/m-section-header'
import Slide from '~/components/_archive/m-slide'
import SocialLinks from '~/components/_archive/m-social-links'
import Thumbnail from '~/components/_archive/m-thumbnail-v2'
import GenericText from '~/components/_archive/a-generic-text'
import ImageSource from '~/components/_archive/a-image'
import Link from '~/components/_archive/a-link'
import Awards from '~/components/_archive/o-awards'
import Carousel from '~/components/_archive/o-carousel'
import Clients from '~/components/_archive/o-clients'
import JobList from '~/components/_archive/o-job-list'
import ArticleBgVideo from '@/components/_archive/o-article-bg-video'
import ArticleBlock from '@/components/_archive/o-article-wrapper'
import Capabilities from '@/components/_archive/o-capabilities'
import FeaturesList from '@/components/_archive/o-features-list'
import OurWorkList from '~/components/_archive/o-our-work-list'
import PracticeLeads from '~/components/_archive/o-contact-leads'
import SiteHeader from '~/components/_archive/o-site-header'
import SiteFooter from '~/components/_archive/o-site-footer'
import SlideProjector from '@/components/_archive/o-slide-projector'
import ONewsListing from '@/components/_archive/o-list-news'
import OCarouselV1 from '~/components/_archive/o-carousel-v1'

Vue.component('OArticleBgVideo', ArticleBgVideo)
Vue.component('BlokOArticleBgVideo', ArticleBgVideo)
Vue.component('OArticleBlock', ArticleBlock)
Vue.component('BlokOArticleBlock', ArticleBlock)
Vue.component('OAwards', Awards)
Vue.component('BlokOAwards', Awards)
Vue.component('OCapabilities', Capabilities)
Vue.component('BlokOCapabilities', Capabilities)
Vue.component('OCarousel', Carousel)
Vue.component('BlokOCarousel', Carousel)
Vue.component('OClients', Clients)
Vue.component('BlokOClients', Clients)
Vue.component('OFeaturesList', FeaturesList)
Vue.component('BlokOFeaturesList', FeaturesList)
Vue.component('OJobList', JobList)
Vue.component('BlokOJobList', JobList)
Vue.component('ONewsInsights', ONewsListing)
Vue.component('BlokONewsinsights', ONewsListing)
Vue.component('BlokONewsInsights', ONewsListing)
Vue.component('ONewsListing', ONewsListing)
Vue.component('OOurWorkList', OurWorkList)
Vue.component('BlokOOurWorkList', OurWorkList)
Vue.component('OPracticeLeads', PracticeLeads)
Vue.component('BlokOPracticeLeads', PracticeLeads)
Vue.component('OSiteHeader', SiteHeader)
Vue.component('BlokOSiteHeader', SiteHeader)
Vue.component('OSiteFooter', SiteFooter)
Vue.component('BlokOSiteFooter', SiteFooter)
Vue.component('OSlideProjector', SlideProjector)
Vue.component('BlokOSlideProjector', SlideProjector)
Vue.component('OCarouselV1', OCarouselV1)
Vue.component('AGenericText', GenericText)
Vue.component('BlokAGenericText', GenericText)
Vue.component('BlokAImageSource', ImageSource)
Vue.component('AImage', ImageSource)
Vue.component('BlokALink', Link)
Vue.component('ALink', Link)
Vue.component('AScrollIndicator', ScrollIndicator)
Vue.component('MArticleVideo', ArticleVideo)
Vue.component('BlokMArticleVideo', ArticleVideo)
Vue.component('MFeatureCard', FeatureCard)
Vue.component('BlokMFeatureCard', FeatureCard)
Vue.component('MLondonOffice', LondonOffice)
Vue.component('BlokMLondonOffice', LondonOffice)
Vue.component('MOfficeCard', OfficeCard)
Vue.component('BlokMOfficeCard', OfficeCard)
Vue.component('MPracticeLeadItem', PracticeLeadItem)
Vue.component('BlokMPracticeLeadItem', PracticeLeadItem)
Vue.component('MSectionHeader', SectionHeader)
Vue.component('BlokMSectionHeader', SectionHeader)
Vue.component('MSlide', Slide)
Vue.component('BlokMSlide', Slide)
Vue.component('MSocialLinks', SocialLinks)
Vue.component('BlokMSocialLinks', SocialLinks)
Vue.component('MThumbnail', Thumbnail)
Vue.component('BlokMThumbnail', Thumbnail)
